import { useEffect, useState } from "react";

import * as S from "./styles";
import { ColorPicker } from "@/main/components/shared/ColorPicker/colorPicker";
import { getLuminance } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { IInsurerRegisterForm } from "../context";
import KOGFileUploader from "@/main/components/shared/fileUploader/fileUploader";
import KogModalSlideImages from "@/main/components/shared/KogModalSlideImages/modalSlideImages";
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";
import { parameterApi } from "@/main/api";
import { ParameterTypeEnum } from "@/main/services/enum/ParameterTypeEnum";
import { toast } from "react-toastify";
import colors from "@/main/style/colors";
import SecondaryButton from "@/main/components/shared/button/secondaryButton";
interface IVisualIdentity {
	companyLogo: File[];
	setCompanyLogo: (files: File[]) => void;
}

const LUMINANCE_THRESHOLD = 0.78;

export default function VisualIdentity({ companyLogo, setCompanyLogo }: IVisualIdentity) {
	const { setValue, watch } = useFormContext<IInsurerRegisterForm>();
	const watcherPrimaryColor = watch("primaryColor");
	const watcherHeaderColor = watch("headerColor");

	const [imageIndex, setImageIndex] = useState(0);
	const [isOpenModalFade, setIsOpenModalFade] = useState<boolean>(false);
	const [imageLogo, setImageLogo] = useState<string[]>([]);
	const [maxFileSize, setMaxFileSize] = useState<number | undefined>(undefined);

	useEffect(() => {
		if (companyLogo && companyLogo.length > 0) {
			const imagesString: string[] = [];
			companyLogo.map((item) => {
				if (item.type === "url") {
					return imagesString.push(item.name);
				}
				if ((item as File) && item.type.startsWith("image")) {
					return imagesString.push(URL.createObjectURL(item as File));
				}
			});
			return setImageLogo(imagesString);
		}
		return setImageLogo([]);
	}, [companyLogo]);

	useEffect(() => {
		loadParameter();
	}, []);

	useEffect(() => {
		if (isNullUndefined(watcherPrimaryColor)) return;
		const luminance = getLuminance(watcherPrimaryColor);
		if (luminance > LUMINANCE_THRESHOLD) {
			toast.warning(getTranslateByKey("information.warningPrimaryColor"));
		}
	}, [watcherPrimaryColor]);

	function loadParameter() {
		parameterApi.getParametersByType(ParameterTypeEnum.MaximumCompanyLogoSize).then((res) => {
			const { result } = res.data;
			if (result) {
				setMaxFileSize(Number(result[0].value));
			}
		});
	}

	function handleClickPreview(index: number, _urlFile: string) {
		setImageIndex(index);
		setIsOpenModalFade(true);
	}
	return (
		<S.Container>
			<form style={{ width: "100%" }}>
				<S.HeaderSection>
					<S.HeaderText>{getTranslateByKey("information.visualIdentity")}</S.HeaderText>
				</S.HeaderSection>

				<S.AreaForm>
					<S.ContainerColor>
						<S.HeaderSection>
							<S.HeaderText>{getTranslateByKey("information.primaryColor")}</S.HeaderText>
							{watcherPrimaryColor && (
								<SecondaryButton
									type="button"
									onClick={() => setValue("primaryColor", colors.pantone2726C)}
									style={{
										padding: "0.2rem 0.8rem",
										marginLeft: "auto",
									}}
								>
									{getTranslateByKey("information.clear")}
								</SecondaryButton>
							)}
						</S.HeaderSection>
						<ColorPicker
							onChange={(color: string) => setValue("primaryColor", color, { shouldValidate: true })}
							value={watcherPrimaryColor}
						/>
					</S.ContainerColor>

					<S.ContainerColor>
						<S.HeaderSection>
							<S.HeaderText>{getTranslateByKey("information.headerColor")}</S.HeaderText>
							{watcherHeaderColor && (
								<SecondaryButton
									type="button"
									onClick={() =>
										setValue("headerColor", colors.headerColor, {
											shouldValidate: true,
										})
									}
									style={{
										padding: "0.2rem 0.8rem",
										marginLeft: "auto",
									}}
								>
									{getTranslateByKey("information.clear")}
								</SecondaryButton>
							)}
						</S.HeaderSection>

						<ColorPicker
							onChange={(color: string) => setValue("headerColor", color, { shouldValidate: true })}
							value={watcherHeaderColor}
						/>
					</S.ContainerColor>

					<S.ContainerImage>
						<KOGFileUploader
							files={companyLogo}
							setFiles={setCompanyLogo}
							maxFiles={1}
							typeFiles={["image"]}
							isFullScreenDragDrop
							handleClickPreviewCustom={handleClickPreview}
							maxTotalSize={maxFileSize}
						/>
					</S.ContainerImage>

					{imageLogo && imageLogo.length > 0 && (
						<KogModalSlideImages
							images={imageLogo}
							imageIndex={imageIndex}
							isOpen={isOpenModalFade}
							setIsOpen={setIsOpenModalFade}
						/>
					)}
				</S.AreaForm>
			</form>
		</S.Container>
	);
}
